import ReactMarkdown from 'react-markdown';
import PropTypes from 'prop-types';
import {
  createMarkdownComponents,
  markdownRehypePlugins,
  markdownRemarkPlugins,
  useMarkdownStyles,
} from './markdown-theme';

const markdownComponents = createMarkdownComponents();

const MarkdownContent = ({ children, className, rehypePlugins = [] }) => {
  const markdownClassName = useMarkdownStyles(className);

  return (
    <div className={markdownClassName}>
      <ReactMarkdown
        components={markdownComponents}
        rehypePlugins={[...markdownRehypePlugins, ...rehypePlugins]}
        remarkPlugins={markdownRemarkPlugins}
        skipHtml
      >
        {children || ''}
      </ReactMarkdown>
    </div>
  );
};

MarkdownContent.propTypes = {
  children: PropTypes.string,
  className: PropTypes.string,
  rehypePlugins: PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.func, PropTypes.array])),
};

MarkdownContent.defaultProps = {
  children: '',
  className: undefined,
};

export default MarkdownContent;
